module.exports = __webpack_public_path__ + "img/FilterIcon.a91baa70.svg";